import type { ViewUIInput } from '@salescore/core'
import { Input, message } from 'antd'
import { t } from 'i18next'
import { useContext, useEffect, useState } from 'react'

import { useViewUIRecordNodeContext } from './contexts'
import { ViewUIContext } from './ViewUIComponent'
import { viewUiValidation } from './viewUiValidation'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ViewUIInputC({ component }: { component: ViewUIInput }) {
  const { isEditMode } = useContext(ViewUIContext)
  const { getValue, onChange } = useViewUIRecordNodeContext()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const value = getValue(component.fieldName) as string
  const errors = component.showError === true ? viewUiValidation(value, component) : []
  const [text, setText] = useState(value)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setText(value)
  }, [value])

  if (component.textarea === true) {
    return (
      <Input.TextArea
        style={
          errors.length === 0
            ? {}
            : {
                borderColor: 'red',
              }
        }
        value={text}
        onBlur={(e) => {
          onChange({ fieldName: component.fieldName, value: text })
        }}
        onChange={(e) => {
          setText(e.target.value)
        }}
        autoSize
        readOnly={isEditMode}
      />
    )
  }
  return (
    <Input
      status={errors.length > 0 ? 'error' : undefined}
      value={text}
      onBlur={(e) => {
        onChange({ fieldName: component.fieldName, value: text })
      }}
      onChange={(e) => {
        setText(e.target.value)
      }}
      onClick={() => {
        if (component.readonly === true) {
          void message.warning(t(`この項目は書き込みが禁止されています。`))
        }
      }}
      readOnly={isEditMode || component.readonly}
    />
  )
}
